import { render, staticRenderFns } from "./errCheck.vue?vue&type=template&id=19464989&"
import script from "./errCheck.vue?vue&type=script&lang=js&"
export * from "./errCheck.vue?vue&type=script&lang=js&"
import style0 from "./errCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../mercari_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports